<!--
/*
 * This file is part of peacohrm Inc
 *
 * Copyright (C) 2020 onwards peacohrm Inc
 *
 * This program is free software; you can redistribute it and/or modify
 * it under the terms of the GNU General Public License as published by
 * the Free Software Foundation; either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License
 * along with this program.  If not, see  http://www.gnu.org/licenses
 */
-->

<template>
  <g transform="matrix(0.973017, 0, 0, 0.973017, 13.833999, 0.907639)">
    <g>
      <g>
        <path
          d="M352.459,220c0-11.046-8.954-20-20-20h-206c-11.046,0-20,8.954-20,20s8.954,20,20,20h206 C343.505,240,352.459,231.046,352.459,220z"
        />
        <path
          d="M126.459,280c-11.046,0-20,8.954-20,20c0,11.046,8.954,20,20,20H251.57c11.046,0,20-8.954,20-20c0-11.046-8.954-20-20-20 H126.459z"
        />
        <path
          d="M173.459,472H106.57c-22.056,0-40-17.944-40-40V80c0-22.056,17.944-40,40-40h245.889c22.056,0,40,17.944,40,40v123 c0,11.046,8.954,20,20,20c11.046,0,20-8.954,20-20V80c0-44.112-35.888-80-80-80H106.57c-44.112,0-80,35.888-80,80v352 c0,44.112,35.888,80,80,80h66.889c11.046,0,20-8.954,20-20C193.459,480.954,184.505,472,173.459,472z"
        />
        <path
          d="M467.884,289.572c-23.394-23.394-61.458-23.395-84.837-0.016l-109.803,109.56c-2.332,2.327-4.052,5.193-5.01,8.345 l-23.913,78.725c-2.12,6.98-0.273,14.559,4.821,19.78c3.816,3.911,9,6.034,14.317,6.034c1.779,0,3.575-0.238,5.338-0.727 l80.725-22.361c3.322-0.92,6.35-2.683,8.79-5.119l109.573-109.367C491.279,351.032,491.279,312.968,467.884,289.572z M333.776,451.768l-40.612,11.25l11.885-39.129l74.089-73.925l28.29,28.29L333.776,451.768z M439.615,346.13l-3.875,3.867 l-28.285-28.285l3.862-3.854c7.798-7.798,20.486-7.798,28.284,0C447.399,325.656,447.399,338.344,439.615,346.13z"
        />
        <path
          d="M332.459,120h-206c-11.046,0-20,8.954-20,20s8.954,20,20,20h206c11.046,0,20-8.954,20-20S343.505,120,332.459,120z"
        />
      </g>
    </g>
  </g>
  <g transform="matrix(0.973017, 0, 0, 0.973017, 13.833999, 0.907639)" />
  <g transform="matrix(0.973017, 0, 0, 0.973017, 13.833999, 0.907639)" />
  <g transform="matrix(0.973017, 0, 0, 0.973017, 13.833999, 0.907639)" />
  <g transform="matrix(0.973017, 0, 0, 0.973017, 13.833999, 0.907639)" />
  <g transform="matrix(0.973017, 0, 0, 0.973017, 13.833999, 0.907639)" />
  <g transform="matrix(0.973017, 0, 0, 0.973017, 13.833999, 0.907639)" />
  <g transform="matrix(0.973017, 0, 0, 0.973017, 13.833999, 0.907639)" />
  <g transform="matrix(0.973017, 0, 0, 0.973017, 13.833999, 0.907639)" />
  <g transform="matrix(0.973017, 0, 0, 0.973017, 13.833999, 0.907639)" />
  <g transform="matrix(0.973017, 0, 0, 0.973017, 13.833999, 0.907639)" />
  <g transform="matrix(0.973017, 0, 0, 0.973017, 13.833999, 0.907639)" />
  <g transform="matrix(0.973017, 0, 0, 0.973017, 13.833999, 0.907639)" />
  <g transform="matrix(0.973017, 0, 0, 0.973017, 13.833999, 0.907639)" />
  <g transform="matrix(0.973017, 0, 0, 0.973017, 13.833999, 0.907639)" />
  <g transform="matrix(0.973017, 0, 0, 0.973017, 13.833999, 0.907639)" />
</template>
